import { useMutation, useQueryClient } from "@tanstack/react-query"
import { mutationHandler } from "../mutationHandler.ts"
import { useNavigate } from "react-router-dom"

const cloneMoneyFlow = (moneyflowId: string) =>
    fetch(`/api/moneyflow/${moneyflowId}/clone`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
    })

export const useCloneMoneyFlowMutation = (
    moneyflowId: string,
) => {
    const queryClient = useQueryClient()
    const navigate = useNavigate()
    return useMutation({
        mutationFn: () => mutationHandler<string>(cloneMoneyFlow(moneyflowId)),
        onSuccess: (data) => {
            navigate(`/moneyflow/${data}`)
            queryClient.invalidateQueries({ queryKey: ['moneyflow'] })
        },
    })
}
